<template>
  <div class="job-data flex-column">
    <!-- <headers></headers> -->
    <div class="manage-wrapper">
      <el-breadcrumb separator="/" class="bread-crumb">
        <el-breadcrumb-item :to="{ path: '/item-list' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home/manage/job' }">作业管理</el-breadcrumb-item>
        <el-breadcrumb-item>学员整体数据</el-breadcrumb-item>
      </el-breadcrumb>
      <img src="@/assets/images/teach/job-data.png" alt="">
    </div>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="less" scoped>
  .job-data {
    min-height: 100vh;

    .manage-wrapper {
      flex: 1;
    }
  }
</style>